import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  setSubChildId,
  prefixCurriculumName,
} from "Administrator/modules/AdministratorModule";
import { getSelectedCurriculumId } from "modules/CommonSelectors";

export default store => ({
  path: "checklist",
  component: withAsyncRouteLoading(
    () =>
      new Promise((cb, reject) => {
        require.ensure(
          [],
          require => {
            const component = require("./components").default;
            cb(component);
          },
          err => {
            reject(err);
          },
          "admin-academicSetup"
        );
      })
  ),
  onEnter() {
    const state = store.getState();
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: "CHECKLIST_SETUP",
        curriculumProgramId: getSelectedCurriculumId(state),
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
